/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuthorizeResponseBody = {
  /**
   * The opaque one-time code. Hand this to the device agent, which redeems it with its code_verifier.
   */
  code: string;
  /**
   * Lifetime of the code in seconds.
   */
  expiresIn: number;
};

/** @internal */
export const AuthorizeResponseBody$inboundSchema: z.ZodMiniType<
  AuthorizeResponseBody,
  unknown
> = z.pipe(
  z.object({
    code: z.string(),
    expires_in: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "expires_in": "expiresIn",
    });
  }),
);

export function authorizeResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<AuthorizeResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthorizeResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthorizeResponseBody' from JSON`,
  );
}
